import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore, isMobile } from '@pascal/pascal-core';
import DecisionActionButtons from '../../components/decisionActionButtons';
import DoubleOrSplitButtons from '../../components/doubleOrSplitButtons';
import { gameStore } from '../../store/gameStore';
import { DECISION_ACTION_TYPES } from '../../enums/betTypes';
import { gameService } from '../../services';
import { doBetStore } from '../../store/doBetStore';
import { betResponseCodeByName } from '../../enums/betResponseCode';
import InsuranceButtons from '../../components/insuranceButtons';

const DecisionButtonsWr = observer(({ isShowDesicion }) => {
  const {
    possibleBetActions,
    isShowDecision,
    hasInsurance,
    liveDecisionActionCounts,
    partnerHasSurrenderAction,
    setHasInsurance,
    setToggleTimer,
  } = gameStore;
  const { lastBetModel, handleNotificationCode } = doBetStore;
  const { balance } = userInfoStore;

  const isBetExceedingLimit = (firstBetAmount, balanceCheck) =>
    freeBetStore.activeFreeBet?.id
      ? firstBetAmount > freeBetStore.activeFreeBet.count
      : balanceCheck;

  const handleDecisionAction = useCallback(
    (betType) => {
      const firstBetAmount = lastBetModel?.betModel?.[0]?.amount || 0;
      const isDoubleOrSplit =
        betType === DECISION_ACTION_TYPES.Double || betType === DECISION_ACTION_TYPES.Split;

      if (isDoubleOrSplit && isBetExceedingLimit(firstBetAmount, firstBetAmount > balance)) {
        handleNotificationCode(betResponseCodeByName.NotEnoughBalance);
        return;
      }
      gameService.sendDecisionAction(betType);
    },
    [lastBetModel, balance, handleNotificationCode]
  );

  const handleCloseInsurance = useCallback(() => {
    setHasInsurance(false);
    setToggleTimer(true);
  }, [setHasInsurance]);

  if (isShowDesicion && (possibleBetActions?.length || hasInsurance) && isShowDecision) {
    return (
      <div className={`${isMobile() ? 'm-' : ''}decision-buttons`}>
        {hasInsurance && (
          <InsuranceButtons
            handleDecisionAction={handleDecisionAction}
            handleCloseInsurance={handleCloseInsurance}
            liveDecisionActionCounts={liveDecisionActionCounts}
          />
        )}
        {!hasInsurance && possibleBetActions?.length > 2 && (
          <DoubleOrSplitButtons
            liveDecisionActionCounts={liveDecisionActionCounts}
            handleDecisionAction={handleDecisionAction}
            possibleActions={possibleBetActions}
          />
        )}
        {!hasInsurance && (
          <DecisionActionButtons
            partnerHasSurrenderAction={partnerHasSurrenderAction}
            liveDecisionActionCounts={liveDecisionActionCounts}
            handleDecisionAction={handleDecisionAction}
            possibleActions={possibleBetActions}
          />
        )}
      </div>
    );
  }
  return null;
});
export default DecisionButtonsWr;
